import React, { useRef, useEffect } from 'react';

interface RootTabProps {
  value: string;
  activeTab: string;
  children: React.ReactNode;
  keepMountedAfterActivation?: boolean;
}

const styles = {
  root: {
    height: '100%',
    minHeight: '100%',
  },
};

export const RootTab = ({
  value,
  activeTab,
  children,
  keepMountedAfterActivation = false,
}: RootTabProps) => {
  const isActive = value === activeTab;
  const hasBeenActivatedRef = useRef(false);

  useEffect(() => {
    if (isActive) {
      hasBeenActivatedRef.current = true;
    }
  }, [isActive]);

  const shouldMount = isActive || (keepMountedAfterActivation && hasBeenActivatedRef.current);

  if (!shouldMount) {
    return null;
  }

  return (
    <div role="tabpanel" hidden={!isActive} aria-hidden={!isActive} style={styles.root}>
      {children}
    </div>
  );
};
